module.exports = __webpack_public_path__ + "media/tkl_promo_mobile_final_nosound.1916fcd1.mp4";